import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "../../../assets/css/slick/slick.min.css";
import { DetalleGridWrapper } from "./styled";
import ModeloDetalleGridItem from "../ModeloDetalleGridItem";
import SliderArrow from "../SliderArrow";
import SliderDots from "../SliderDots";
import API from "../../../classes/api";

const ModelosDetalleGrid = ({ cols, carline, salesgroup, ofertas, mode }) => {
	const [isSlider, setIsSlider] = useState(false);
	const [collapseSlidesFeatures, setCollapseSlidesFeatures] = useState(false);
	const sliderSettings = {
		dots: true,
		arrows: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: (
			<div>
				<SliderArrow color="dark" position="prev" outside={true} />
			</div>
		),
		nextArrow: (
			<div>
				<SliderArrow color="dark" position="next" outside={true} />
			</div>
		),
		appendDots: (dots) => <SliderDots dots={dots} />,
		beforeChange: () => setCollapseSlidesFeatures(true),
	};

	const getPriceNote = (oferta) => {
		if (mode === "opcion-futuro") {
			return (
				<>
					<p>
						{oferta.oferta?.cuotaEntrada ? (
							<span>
								{API.formatPrecio(oferta.oferta?.cuotaEntrada)}€ de
								entrada&nbsp;|&nbsp;
							</span>
						) : (
							<span>Sin entrada&nbsp;|&nbsp;</span>
						)}
						{oferta.oferta?.cuotaFinal ? (
							<span>
								{API.formatPrecio(oferta.oferta?.cuotaFinal)}€ cuota
								final
							</span>
						) : null}
					</p>
					<p>
						<span>{oferta.oferta?.plazos} cuotas&nbsp;|&nbsp;</span>
						<span>
							<strong>
								<u>{API.formatPrecio(oferta.oferta?.tae)}% TAE</u>
							</strong>
							&nbsp;|&nbsp;
						</span>
						<span>{API.formatPrecio(oferta.oferta?.tin)}% TIN</span>
					</p>
				</>
			);
		} else if (mode === "renting") {
			return (
				<>
					<p>
						{oferta.oferta?.cuotaEntrada ? (
							<span>
								{API.formatPrecio(oferta.oferta?.cuotaEntrada)}€
								entrada&nbsp;|&nbsp;
							</span>
						) : (
							<span>Sin entrada&nbsp;|&nbsp;</span>
						)}
						<span>{oferta.oferta?.plazos} cuotas</span>
					</p>
				</>
			);
		} else if (mode === "renting-empresa") {
			return (
				<>
					<p>
						<span>{oferta.oferta?.plazos} cuotas&nbsp;|&nbsp;</span>
						<span>
							{API.formatPrecio(oferta.oferta?.kilometros, false)} km
						</span>
					</p>
				</>
			);
		} else {
			return (
				<>
					<p>
						<span>
							{oferta.oferta.info !== null ? oferta.oferta.info : ""}
							&nbsp;
						</span>
						{oferta.oferta?.cuotaEntrada ? (
							<span>
								Entrada: {API.formatPrecio(oferta.oferta?.cuotaEntrada)}
								€
							</span>
						) : (
							<span>Sin entrada&nbsp;|&nbsp;</span>
						)}
					</p>
				</>
			);
		}
	};

	const resizeListener = () => {
		if (window.innerWidth > 768) {
			setIsSlider(false);
		} else {
			setIsSlider(true);
		}
	};

	useEffect(() => {
		resizeListener();
		window.addEventListener("resize", resizeListener);

		return () => {
			window.removeEventListener("resize", resizeListener);
		};
	}, []);

	return (
		<DetalleGridWrapper cols={cols} noPaddingTopBot={true}>
			{isSlider ? (
				<Slider {...sliderSettings}>
					{ofertas.map((oferta, index) => {
						return (
							<ModeloDetalleGridItem
								key={index}
								cols={cols}
								image={oferta.trimlevel?.imagenes?.tresCuartos?.l}
								preTitle={`${salesgroup.nuevo ? "Nuevo" : ""} Audi ${
									carline.titulo
								} ${salesgroup.titulo} ${oferta.trimlevel.titulo}`}
								title={`${
									oferta.oferta?.modalidad
								} <strong>${API.formatPrecio(
									oferta.oferta?.precio,
									false,
								)}€/${oferta.oferta?.periodicidad}</strong>*`}
								subtitle={oferta.oferta?.tipologia}
								price={`En ${oferta.oferta?.plazos} cuotas.`}
								// priceExtra={
								// 	mode === "opcion-futuro" &&
								// 	`TAE ${API.formatPrecio(
								// 		oferta.oferta?.tae,
								// 	)}% | TIN ${API.formatPrecio(oferta.oferta?.tin)}%`
								// }
								priceNote={getPriceNote(oferta)}
								model={`Motor: ${oferta.oferta?.motorizacion}`}
								buttons={
									oferta.oferta &&
									oferta.oferta.botones &&
									oferta.oferta.botones.map((boton) => {
										return {
											text: boton.etiqueta,
											url: boton.url,
											nuevaVentana: boton.nuevaVentana,
											dataBtnSolicitarOferta: "solicitar_oferta",
											dataFinanciacion: oferta.oferta.tipo,
											dataModelEdition: salesgroup.codigo,
										};
									})
								}
								featuresList={API.buildFeaturesFromOferta(
									oferta.oferta,
								)}
								collapseSlidesFeatures={collapseSlidesFeatures}
								setCollapseSlidesFeatures={setCollapseSlidesFeatures}
								consumo={salesgroup.legalConsumos}
								legal={oferta.oferta?.legal}
							/>
						);
					})}
				</Slider>
			) : (
				ofertas.map((oferta, index) => {
					return (
						<ModeloDetalleGridItem
							key={index}
							cols={cols}
							image={oferta.trimlevel?.imagenes?.tresCuartos.l}
							preTitle={`${salesgroup.nuevo ? "Nuevo" : ""} Audi ${
								carline.titulo
							} ${salesgroup.titulo} ${oferta.trimlevel.titulo}`}
							title={`${
								oferta.oferta?.modalidad
							} <strong>${API.formatPrecio(
								oferta.oferta?.precio,
								false,
							)}€/${oferta.oferta?.periodicidad}</strong>*`}
							subtitle={oferta.oferta?.tipologia}
							// price={`En ${oferta.oferta?.plazos} cuotas.`}
							// priceExtra={
							// 	mode === "opcion-futuro" &&
							// 	`TAE ${API.formatPrecio(
							// 		oferta.oferta?.tae,
							// 	)}% | TIN ${API.formatPrecio(oferta.oferta?.tin)}%`
							// }
							priceNote={getPriceNote(oferta)}
							model={`Motor: ${oferta.oferta?.motorizacion}`}
							buttons={
								oferta.oferta &&
								oferta.oferta.botones &&
								oferta.oferta.botones.map((boton) => {
									return {
										text: boton.etiqueta,
										url: boton.url,
										nuevaVentana: boton.nuevaVentana,
										dataBtnSolicitarOferta: "solicitar_oferta",
										dataFinanciacion: oferta.oferta.tipo,
										dataModelEdition: salesgroup.codigo,
									};
								})
							}
							featuresList={API.buildFeaturesFromOferta(oferta.oferta)}
							consumo={salesgroup.legalConsumos}
							legal={oferta.oferta?.legal}
						/>
					);
				})
			)}
		</DetalleGridWrapper>
	);
};

export default ModelosDetalleGrid;
